import { render, staticRenderFns } from "./pro.vue?vue&type=template&id=0065f8ee"
import script from "./pro.vue?vue&type=script&lang=js"
export * from "./pro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports